import React, {useEffect} from 'react'
import Snapshot from './EOFYSaleSubSections/Snapshot'
import CustomerReplies from './EOFYSaleSubSections/CustomerReplies'
import OptOutTab from './EOFYSaleSubSections/OptOutTab'
import ShortLink from './EOFYSaleSubSections/ShortLink'
import BouncedTab from './EOFYSaleSubSections/BouncedTab'
import {Routes, Route, Outlet, Navigate, useLocation} from 'react-router-dom'
import ReportPageHeader from './ReportPageHeader'
import {useDispatch, useSelector} from 'react-redux'
import {
  GetReportId,
  GetSingleMessageData,
  getSingleMessageReport,
} from './reportSlices/reportAnalytics'
import ContactList from './EOFYSaleSubSections/ContactList'

const ReportPageWrapper = () => {
  const param = useLocation()
  const dispatch = useDispatch()
  const ReportId = useSelector(GetReportId)
  
  useEffect(() => {
    dispatch(getSingleMessageReport({id: ReportId?.id, params: {camp_type: ReportId?.camp_type}}))
  }, [])
  return (
    <>
      <Routes>
        <Route
          element={
            <>
              <ReportPageHeader />
            </>
          }
        >
          <Route index element={<Navigate to='*/eofy/snapshot' replace={true} />} />
          <Route
            path='snapshot'
            element={
              <>
                <Snapshot />
              </>
            }
          />

          <Route path='customer_replies' element={<CustomerReplies />} />
          <Route path='contacts' element={<ContactList />} />

          <>
            <Route path='opt_out' element={<OptOutTab />} />

            <Route path='short_link' element={<ShortLink />} />
            <Route path='bounced' element={<BouncedTab />} />
          </>
        </Route>
      </Routes>
    </>
  )
}

export default ReportPageWrapper
